import { QueryClient } from '@tanstack/react-query'

/**
 * Satu klien kueri untuk seluruh aplikasi, dipakai tampilan lama dan rancang ulang.
 *
 * Dipindah dari `App.jsx` saat penyedianya naik ke `Akar.jsx`. Ia modul sendiri supaya
 * sesi bisa mengosongkannya saat orang keluar, tanpa mengimpor pohon rute.
 */
export const klienKueri = new QueryClient({
  defaultOptions: {
    queries: {
      // Layar ini dibuka lalu ditinggal berjam-jam; menyegarkan saat jendela
      // difokuskan lagi lebih berguna daripada polling, dan jauh lebih murah.
      refetchOnWindowFocus: true,
      staleTime: 30_000,
      retry: (gagalKe, galat) => {
        // 4xx tidak akan berubah dengan diulang. Yang layak diulang cuma
        // jaringan mati dan 5xx.
        if (galat?.status >= 400 && galat?.status < 500) return false
        return gagalKe < 2
      },
    },
  },
})
